import { render, staticRenderFns } from "./CollapseAction.vue?vue&type=template&id=a0bdde64&scoped=true&"
import script from "./CollapseAction.vue?vue&type=script&lang=js&"
export * from "./CollapseAction.vue?vue&type=script&lang=js&"
import style0 from "./CollapseAction.vue?vue&type=style&index=0&id=a0bdde64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bdde64",
  null
  
)

export default component.exports